import dayjs from 'dayjs';
import React from 'react';
import { Formik, Form } from 'formik';

import { Grid } from '@mui/material';

import { Button, Autocomplete } from 'shared';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { agentMatchingFiltersStyles } from '../../../style/style';
import { agentMatchingTypes } from '../../../utils/agentMatchingTypes';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { schema, initialValues } from '../../../utils/agentMatchingSchema';

const AgentMatchingFilters = ({ handleFiltersSubmit }) => {
    const classes = agentMatchingFiltersStyles();

    const handleClearClick = (handleReset) => {
        handleReset();
        handleFiltersSubmit({});
    };

    const handleSubmitClick = (values) => {
        const filterValues = {
            startDate: values?.startDate ? dayjs(values.startDate).format('YYYY-MM-DD') : null,
            endDate: values?.endDate ? dayjs(values.endDate).format('YYYY-MM-DD') : null,
            type: values?.type?.value,
        };

        handleFiltersSubmit(filterValues);
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={schema}
            onSubmit={handleSubmitClick}
        >
            {({ values, handleReset, setFieldValue }) => {
                return (
                    <Form>
                        <Grid container spacing={2}>
                            <Grid item xs={3}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        value={values.startDate && dayjs(values.startDate)}
                                        onChange={(date) => setFieldValue('startDate', date)}
                                        label="Start Date"
                                        placeholder="Start Date"
                                        format="MM-DD-YYYY"
                                        sx={classes.datePicker}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={3}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        value={values.endDate && dayjs(values.endDate)}
                                        onChange={(date) => setFieldValue('endDate', date)}
                                        label="End Date"
                                        placeholder="End Date"
                                        format="MM-DD-YYYY"
                                        sx={classes.datePicker}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={3}>
                                <Autocomplete
                                    options={agentMatchingTypes}
                                    labelKey="label"
                                    valueKey="value"
                                    placeholder="Match Type"
                                    name="type"
                                    inlineLabel="Match Type"
                                    value={values.type}
                                    onChange={(e, value) => setFieldValue('type', value)}
                                    isSearchField={false}
                                    disableClearable
                                    customStyle={classes.dropdown}
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} alignItems="end" justifyContent="end">
                            <Grid item marginTop="10px" marginBottom="10px">
                                <Button
                                    text="Clear"
                                    onClick={() => handleClearClick(handleReset)}
                                    customStyles={classes.cancelButton}
                                />
                                <Button text="Apply" type="submit" />
                            </Grid>
                        </Grid>
                    </Form>
                );
            }}
        </Formik>
    );
};

export default AgentMatchingFilters;
